import axios from 'axios';
import { authToken } from './AuthHandler';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

const restEndoint = 'https://islandpoke-web.herokuapp.com';
// const restEndoint = 'https://662c6287.ngrok.io' //preda;
const timeout = 15000;

class HttpHandler {
	get = (endpoint, params) => {
		console.log('Getting Data');
		return axios({
			method: 'get',
			baseURL: restEndoint,
			url: endpoint,
			headers: { Authorization: authToken },
			timeout: timeout,
			params: params,
		});
	};

	post = (endpoint, params, data) => {
		console.log('Posting Data...');
		return axios({
			method: 'post',
			baseURL: restEndoint,
			url: endpoint,
			headers: { Authorization: authToken },
			timeout: timeout,
			params: params,
			data: data,
		});
	};

	put = (endpoint, params, data) => {
		console.log('Puting Data...');
		return axios({
			method: 'put',
			baseURL: restEndoint,
			url: endpoint,
			headers: { Authorization: authToken },
			timeout: timeout,
			params: params,
			data: data,
		});
	};

	delete = (endpoint, params) => {
		console.log('Deleting Data...');
		return axios({
			method: 'delete',
			baseURL: restEndoint,
			url: endpoint,
			headers: { Authorization: authToken },
			timeout: timeout,
			params: params,
		});
	};
}

const httpHandler = new HttpHandler();
export default httpHandler;



// WEBPACK FOOTER //
// ./src/utilities/HttpHandler.js